/**
 * Sortable Module
 */
export * from './sortable';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-lists/src/sortable/index.js
// module id = 1865
// module chunks = 0